module.exports = "/_next/static/images/b0f67fb1bc4ae804fc4c4b9bf6985407-woman-with-yellow-glasses@0.5x.jpg.webp";